import React, { useState } from 'react';
import styles from './ControllerFeatures.module.css';

const CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

const ControllerFeatures = ({
  mainImage,
  mainImageAlt = 'Main Controller',
  additionalImages = [],
  features = [],
  backgroundColor = '',
  className = ''
}) => {
  const [currentMainImage, setCurrentMainImage] = useState(
    additionalImages.length > 0 ? additionalImages[0].src : mainImage
  );
  const [currentMainImageAlt, setCurrentMainImageAlt] = useState(
    additionalImages.length > 0 ? additionalImages[0].alt : mainImageAlt
  );

  const handleImageClick = (image) => {
    setCurrentMainImage(image.src);
    setCurrentMainImageAlt(image.alt);
  };

  return (
    <section 
      className={`${styles.controllerFeaturesSection} ${className}`} 
      style={{ backgroundColor }}
    >
      <div className={styles.contentContainer}>
        <div className={styles.contentGrid}>
          
          {/* Left Section - Main Image + Features */}
          <div className={styles.leftSection}>
            <div className={styles.mainImageSection}>
              <img 
                src={`${CMS_BASE_URL}/attachments/${currentMainImage}`} 
                alt={currentMainImageAlt} 
                className={styles.mainImage}
                loading="lazy"
              />
            </div>

            {features.length > 0 && (
              <div className={styles.featuresSection}>
                {features.map((feature, index) => (
                  <div key={index} className={styles.featureItem}>
                    <div className={styles.featureContent}>
                      <div className={styles.iconWrapper}>
                        <img 
                          src={`${CMS_BASE_URL}/attachments/${feature.icon}`} 
                          alt="Feature icon" 
                          className={styles.featureIconImage}
                          loading="lazy"
                        />
                      </div>
                      <p className={styles.featureLabel}>{feature.label}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Right Section - Additional Images */}
          {additionalImages.length > 0 && (
            <div className={styles.additionalImagesGrid}>
              {additionalImages.map((image, index) => (
                <div 
                  key={index} 
                  className={`${styles.additionalImageContainer} ${
                    currentMainImage === image.src ? styles.activeImage : ''
                  }`}
                  onClick={() => handleImageClick(image)}
                >
                  <img 
                    src={`${CMS_BASE_URL}/attachments/${image.src}`} 
                    alt={image.alt || `Controller View ${index + 1}`} 
                    className={styles.additionalImage}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ControllerFeatures;